module.exports = __webpack_public_path__ + "img/Home.78044465.png";